import React, {useEffect, useState} from "react";
import {Actions} from "../../../client/Actions";
import {Alert, Button, Col, Row} from "react-bootstrap";
import FormatCreationMachineModelFormatParts from "./FormatCreationMachineFormatParts";
import RenderUtils from "../../helpers/renderUtils";
import MachineAdditionalData from "./MachineAdditionalData";
import {MachineHeader} from "./MachineHeader";
import CartonMachineDataFormConfig from "./config/CartonMachineDataFormConfig";
import PackagerMachineDataFormConfig from "./config/PackagerMachineDataFormConfig";
import CommonCartonMachineDataFormConfig from "./config/CommonCartonMachineDataFormConfig";
import { useTranslation } from 'react-i18next';


const MachineConfiguration = ({
                                  format,
                                  machineModel,
                                  full,
                                  setLoader,
                                  withHeader = true,
                                  withDetails = true,
                                  editMode = true,
                                  reload,
                                  onConfigurationFinished,
                                  additionalColumns,
                                  checkAllByDefault,
                                  externalConfigs,
                                  readOnly
                              }) => {

    const { t } = useTranslation();

    const [fullMachineModel, setFullMachineModel] = useState()
    const [configurations, setConfigurations] = useState([])
    const [selectedAdditionalDataConfig, setSelectedAdditionalDataConfig] = useState()
    const [additionalData, setAdditionalData] = useState()


    const additionalDataConfig = {
        "CARTON": {
            name: "cartonMachineData",
            fieldsConfig: CartonMachineDataFormConfig
        },
        "PACKAGER": {
            name: "packagerMachineData",
            fieldsConfig: PackagerMachineDataFormConfig
        },
        "COMMON_CARTON": {
            name: "commonCartonMachineData",
            fieldsConfig: CommonCartonMachineDataFormConfig
        },
    }


    useEffect(() => {
        if (full) {
            machineModelLoaded(full)
        } else if (machineModel) {
            setLoader(true)
            setSelectedAdditionalDataConfig(additionalDataConfig[machineModel.machineType])
            Actions.get("machine-model/" + machineModel.id, machineModelLoaded)
        }
    }, [machineModel])

    useEffect(() => {
        if (readOnly) {
            Actions.get("format/" + format.id + "/parts", loadConfigurations)
        }
    }, [readOnly])

    useEffect(() => {
        if (readOnly && machineModel && format && selectedAdditionalDataConfig) {

            setAdditionalData(format[selectedAdditionalDataConfig.name])

        }
    }, [readOnly, machineModel, format, selectedAdditionalDataConfig])


    const loadConfigurations = (parts) => {
        const result = parts
            .filter(p => p.machineType === machineModel.machineType)
            .filter(p => p.status !== "WITHDRAWN")
            .map(p => {
                return {
                    formatPart: {id: p.formatPartId},
                    type: p.type ? {value: p.type, label: RenderUtils.renderEnumName(p.type, "enums/partType", t)} : null,
                    label: p.label,
                    position: p.position,
                    partNumber: p.partNumber,
                }
            })

        setConfigurations(result)

        setLoader(false)
    }

    const machineModelLoaded = (data) => {
        setFullMachineModel(data)
        setLoader(false)
    }


    const onSave = () => {
        setLoader(true)
        Actions.post("format/" + format.id + "/machine-model", {
            machine: {id: machineModel.id},
            parts: configurations.map(c => {
                return {
                    formatPart: c.formatPart,
                    partType: c.type?.value,
                    position: c.position,
                    partNumber: c.partNumber,
                    label: c.label
                }
            })

        }, onConfigurationsSaved)
    }

    const onConfigurationsSaved = () => {
        if (selectedAdditionalDataConfig) {
            Actions.post(`format/` + format.id + "/" + selectedAdditionalDataConfig.name, additionalData, onConfigurationFinished)
        } else {
            onConfigurationFinished()
        }
    }

    return (
        <>
            {fullMachineModel &&
                <>
                    {editMode &&
                        <Col md={12}>
                            <Alert className={"pb-4"} variant="primary">

                                <i className="fas fa-edit mr-2"></i><strong>
                                {readOnly ?
                                    t("forms.machine_model_details_with_parts") :
                                    t("forms.configuring_machine_model_and_parts")
                                }
                            </strong>
                                {readOnly ?
                                    <>
                                        <Button type="submit"
                                                className={"float-right"}
                                                onClick={onConfigurationFinished}
                                                variant="primary">{t("common.return")}</Button>
                                    </> :
                                    <>
                                        <Button type="submit"
                                                className={"float-right"}
                                                onClick={onSave}
                                                variant="primary">{t("common.save")}</Button>
                                        <Button type="submit"
                                                className={"float-right mr-2"}
                                                onClick={onConfigurationFinished}
                                                variant="secondary">{t("common.cancel")}</Button>
                                    </>
                                }
                            </Alert>
                        </Col>
                    }
                    <Col md={12}>
                        {withHeader &&
                            <Row>
                                <MachineHeader machine={machineModel} packingLineName={machineModel.packingLineName}/>
                            </Row>
                        }

                        {/*<Machine machine={fullMachineModel}*/}
                        {/*         width={12}*/}
                        {/*         withoutParts={true}*/}
                        {/*         withToggle={false}*/}
                        {/*         editable={false}*/}
                        {/*         readOnly={true}*/}
                        {/*/>*/}

                    </Col>
                    <Col md={withDetails && selectedAdditionalDataConfig ? 9 : 12}>
                        <FormatCreationMachineModelFormatParts
                            format={format}
                            machineModel={fullMachineModel}
                            setLoader={setLoader}
                            reload={reload}
                            checkAllByDefault={checkAllByDefault}
                            withHeader={withHeader}
                            readOnly={readOnly}
                            additionalColumns={additionalColumns}
                            externalConfigs={externalConfigs}
                            configurations={configurations}
                            setConfigurations={setConfigurations}
                        />
                    </Col>
                    {withDetails && selectedAdditionalDataConfig && (readOnly ? additionalData : true) &&
                        <Col md={3}>
                            <MachineAdditionalData
                                format={format}
                                machine={fullMachineModel}
                                setLoader={setLoader}
                                reload={reload}
                                readOnly={readOnly}
                                additionalData={additionalData}
                                config={selectedAdditionalDataConfig}
                                setAdditionalData={setAdditionalData}
                            />
                        </Col>
                    }
                </>
            }

        </>
    );
};


export default MachineConfiguration;